import { Row } from "reactstrap"

const NoObjectionLetterPreview = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Legal Status </td>
              <td>{props.data.legal_status}</td>
            </tr>

            <tr>
              <td>Project Name</td>
              <td>{props.data.no_objection_reason}</td>
            </tr>
            <tr>
              <td>Reason</td>
              <td>{props.data.project_name}</td>
            </tr>
            <tr>
              <td>Project Description</td>
              <td>{props.data.project_description}</td>
            </tr>

            {/* <tr>
              <td>Request Details</td>
              <td>{props.data.request_details}</td>
            </tr> */}
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default NoObjectionLetterPreview
